import React from "react";
import { calculateTotalGST } from "./invoice.utility";
import numberToWord from "../../components/common/utlity/invoiceword";
import {
  SaleformatDateByBusinessPreference,
  truncateCommaSeparatedString,
} from "../../components/common/utlity/utility";
import { useTranslation } from "react-i18next";
import { AWS_URL } from "../../services/http.service";
import { Country, State } from "country-state-city";
const LandscapeTheme = ({
  item,
  containerRef,
  businessName,
  phone,
  bussiness,
  // darkMode = false,
}) => {
  const amountInWords = numberToWord(item?.transactionAmount);
  const { t } = useTranslation();
  // const textColor = darkMode ? "#E5E7EB" : "#424242"; // Light gray vs dark
  // const bgColor = darkMode ? "#020617" : "#eff6ff"; // Dark background for dark mode
  // const borderColor = darkMode ? "#374151" : "#3F4154"; // Softer border color in dark mode
  // const headerBgColor = darkMode ? "#1F2937" : "#F2F9FF";
  // const cellBgColor = darkMode ? "#170f2a" : "#eff6ff";
  // const footerBgColor = darkMode ? "#374151" : "#F4F4F4";
  const textColor = "#424242";
const bgColor = "#eff6ff";
const borderColor = "#3F4154";
const headerBgColor = "#F2F9FF";
const cellBgColor = "#eff6ff";
const footerBgColor = "#F4F4F4";




  const businessCountry = bussiness?.country
    ? Country.getCountryByCode(bussiness.country)
    : null;
  const businessState = bussiness?.state
    ? State.getStateByCodeAndCountry(bussiness.state, bussiness.country)
    : null;

  // Customer country/state
  const customerCountry = item?.country
    ? Country.getCountryByCode(item.country)
    : null;
  const customerState = item?.state
    ? State.getStateByCodeAndCountry(item.state, item.country)
    : null;







  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        color: textColor,
        margin: 20,
        backgroundColor: bgColor,
      }}
      ref={containerRef}
    >
      {/* Header Section */}
      <table
        style={{
          borderCollapse: "collapse",
          border: "1pt solid #3F4154",
          marginBottom: 10,
          width: 720,
        }}
      >
        <tbody>
          {/* Invoice Title */}
          <tr>
            <td
              style={{
                border: "1pt solid #3F4154",
                textAlign: "center",
                fontSize: "14px",
                padding: "8px",
                backgroundColor: cellBgColor,
              }}
            >
              <b>{t("NEWINVOICE.TAX_INVOICE")}</b>
            </td>
          </tr>

          {/* Business Details */}
          <tr>
            <td
              style={{
                border: `1pt solid ${borderColor}`,
                padding: "8px",
                backgroundColor: cellBgColor,
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  style={{
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#f3f4f6",
                    marginRight: "8px",
                  }}
                >
                  <img
                    src={
                      bussiness?.businesslogo
                        ? AWS_URL + bussiness.businesslogo
                        : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dSEtDvpd9KAn4SdFJVoL0K1lj4Xfc-wVWQ&s"
                    }
                    alt="Logo"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                    // //crossOrigin="anonymous"
                  />
                </div>

                <div>
                  <span style={{ fontWeight: "bold", fontSize: "13px" }}>
                    {businessName}
                  </span>
                  <div style={{ fontSize: "11px", marginTop: "3px" }}>
                    {bussiness?.firstLine
                      ? `${bussiness.firstLine}, ${businessState?.name || ""}, ${
                          businessCountry?.name || ""
                        }`
                      : "N/A"}
                  </div>
                  <div style={{ fontSize: "11px" }}>
                    GSTIN: {bussiness?.gstNumber || "N/A"}
                  </div>
                  <div style={{ fontSize: "11px" }}>
                    Email: {bussiness?.email || "N/A"}
                  </div>
                </div>
              </div>
            </td>
          </tr>

          {/* Customer & Invoice Info */}
          <tr>
            <td
              style={{
                border: `1pt solid ${borderColor}`,
                padding: "8px",
                backgroundColor: cellBgColor,
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                {/* Customer */}
                <div>
                  <div style={{ fontWeight: "bold" }}>
                    {t("NEWINVOICE.BILL_TO")}:
                  </div>
                  <div>{item.customerName}</div>
                  <div>
                    {t("NEWINVOICE.CONTACT_NO")}: {item.mobile}
                  </div>
                  <div>
                    {t("NEWINVOICE.ADDRESS")}:{" "}
                    {item?.address
                      ? `${item.address}, ${customerState?.name || ""}, ${
                          customerCountry?.name || ""
                        }`
                      : "N/A"}
                  </div>
                </div>

                {/* Invoice Info */}
                <div style={{ textAlign: "right" }}>
                  <div>
                    {t("NEWINVOICE.NO")}: {item.invoiceId}
                  </div>
                  <div>
                    {t("NEWINVOICE.DATE")}{" "}
                    {SaleformatDateByBusinessPreference(
                      item?.saleDate,
                      bussiness?.dateFormat
                    )}
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <table
        style={{
          borderCollapse: "collapse",
          border: "1pt solid #3F4154",
          marginBottom: 10,
          width: 720,
        }}
      >
        <thead>
          <tr bgcolor='#F2F9FF' style={{ fontSize: "11px" }}>
            <th style={{ border: "1pt solid #3F4154" }}>#</th>
            <th style={{ border: "1pt solid #3F4154" }}>
              {t("NEWINVOICE.ITEM_NAME")}
            </th>
            <th style={{ border: "1pt solid #3F4154" }}>
              {t("NEWINVOICE.HSN_SAC")}
            </th>
            <th style={{ border: "1pt solid #3F4154" }}>
              {t("NEWINVOICE.QTY")}
            </th>
            <th style={{ border: "1pt solid #3F4154" }}>
              {t("NEWINVOICE.PRICE_PER_UNIT")}
            </th>
            <th style={{ border: "1pt solid #3F4154" }}>
              {t("NEWINVOICE.DISCOUNT")}
            </th>
            <th style={{ border: "1pt solid #3F4154" }}>
              {t("NEWINVOICE.GST")}
            </th>
            <th style={{ border: "1pt solid #3F4154" }}>
              {t("NEWINVOICE.AMOUNT")}
            </th>
          </tr>
        </thead>
        <tbody>
          {(item?.invoiceId?.startsWith("RT")
            ? item?.returnitems
            : item?.items
          )?.map((itm, index) => (
            <tr
              key={index}
              style={{
                backgroundColor: "#eff6ff",
              }}
            >
              <td style={{ border: "1pt solid #3F4154", textAlign: "center" }}>
                {index + 1}
              </td>
              <td style={{ border: "1pt solid #3F4154" }}>{itm.productName}</td>
              <td style={{ border: "1pt solid #3F4154" }}>
                {truncateCommaSeparatedString(itm.hsnNumber) || "N/A"}
              </td>
              <td style={{ border: "1pt solid #3F4154", textAlign: "right" }}>
                {itm.quantity}
              </td>
              <td style={{ border: "1pt solid #3F4154", textAlign: "right" }}>
                ₹ {itm.salePrice}
              </td>
              <td style={{ border: "1pt solid #3F4154", textAlign: "right" }}>
                ₹ {itm.discount}
              </td>
              <td style={{ border: "1pt solid #3F4154", textAlign: "right" }}>
                {itm.igst}%
              </td>
              <td style={{ border: "1pt solid #3F4154", textAlign: "right" }}>
                ₹ {itm.finalPrice}
              </td>
            </tr>
          ))}
          <tr>
            <td
              // style={{ border: "1pt solid #3F4154" }}
              style={{
                backgroundColor: "#eff6ff",
                fontWeight: "bold",
              }}
            ></td>
            <td
              colSpan={4}
              style={{
                border: "1pt solid #3F4154",
                textAlign: "right",
                backgroundColor: "#eff6ff",
              }}
              className='font-bold'
            >
              {t("NEWINVOICE.TOTAL")}
            </td>
            <td
              style={{
                border: "1pt solid #3F4154",
                textAlign: "right",
                backgroundColor: "#eff6ff",
              }}
            >
              ₹ {item.transactionAmount?.toFixed(2)}
            </td>
            <td
              style={{
                border: "1pt solid #3F4154",
                textAlign: "right",
                backgroundColor: "#eff6ff",
              }}
              className='font-bold'
            >
              {t("NEWINVOICE.TOTAL_GST")}
            </td>
            <td
              style={{
                border: "1pt solid #3F4154",
                textAlign: "right",
                backgroundColor: "#eff6ff",
              }}
            >
              {/* {calculateTotalGST(item)} */}
              {item.igst}
            </td>
          </tr>
        </tbody>
      </table>
      <div className='flex gap-4 mt-4'>
        {/* Left Section */}
        <div className='w-1/2 text-sm space-y-2'>
          <div
            className={`mb-2  p-1`}
            style={{ fontSize: "11px" }}
          >
            {t("NEWINVOICE.SUB_TOTAL")}:{" "}
            <b>₹ {item.transactionAmount?.toFixed(2)}</b>
          </div>

          {item.cgst > 0 && (
            <div className="mb-2 p-1" style={{ fontSize: "11px" }}>
              {t("TAX_WITHOUT_PERC.CGST")}: <b>₹ {parseFloat(item.cgst).toFixed(2)}</b>
            </div>
          )}
          {item.sgst > 0 && (
            <div className="mb-2 p-1" style={{ fontSize: "11px" }}>
              {t("TAX_WITHOUT_PERC.SGST")}: <b>₹ {parseFloat(item.sgst).toFixed(2)}</b>
            </div>
          )}
          {item.igst > 0 && (
            <div className="mb-2 p-1" style={{ fontSize: "11px" }}>
              {t("TAX_WITHOUT_PERC.IGST")}: <b>₹ {parseFloat(item.igst).toFixed(2)}</b>
            </div>
          )}
          {item.cess > 0 && (
            <div className="mb-2 p-1" style={{ fontSize: "11px" }}>
              {t("TAX_WITHOUT_PERC.CESS")}: <b>₹ {parseFloat(item.cess).toFixed(2)}</b>
            </div>
          )}

          <div>{t("NEWINVOICE.RECEIVED")}: ₹ 0.00</div>

          <div>
            <b>{t("NEWINVOICE.TOTAL")}:</b> {amountInWords} {item.amountInWords ? `(${item.amountInWords})` : ""}
          </div>

          <div>
            {t("NEWINVOICE.BALANCE")}: ₹ {item.transactionAmount?.toFixed(2)}
          </div>

          <div>
            {t("NEWINVOICE.PAYMENT_MODE")} : {item.paymentMode}
          </div>

          <div className='mt-3 font-bold'>
            {t("NEWINVOICE.TERMS_CONDITIONS")}:
          </div>
          <div>{t("NEWINVOICE.THANKS_MESSAGE")}</div>

          <div className='mt-3'>
            {t("NEWINVOICE.FOR_COMPANY", { company: businessName })}
          </div>
          <div>{t("NEWINVOICE.AUTHORIZED_SIGNATORY")}</div>
        </div>

        {/* Right Section (Image) */}
        {bussiness?.aadharPhoto && (
          <div className='w-1/2 flex items-start justify-center'>
            <div className='p-4 bg-gray-100 rounded-lg shadow'>
              <img
                src={AWS_URL + bussiness?.aadharPhoto}
                alt='Authorized Signatory'
                className='max-w-full h-auto object-contain'
                // crossOrigin='anonymous'
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LandscapeTheme;
